import { useState, useEffect } from "react";
import useMovieTrailer from "../Hooks/useMovieTrailer";
import { useSelector } from "react-redux";
import { API_OPTIONS } from "../Utils/constant";

const VideoBackground = ({movieId}) => {
  const trailerVideo = useSelector((store) => store.movies?.trailerVideo);
  const [backdropImage, setBackdropImage] = useState(null);
  useMovieTrailer(movieId);

  useEffect(() => {
    // Fetch movie backdrop if no video is available
    if (!trailerVideo?.key && movieId) {
      const fetchBackdrop = async () => {
        try {
          const response = await fetch(
            `https://api.themoviedb.org/3/movie/${movieId}?language=en-US`,
            API_OPTIONS
          );
          const data = await response.json();
          if (data.backdrop_path) {
            setBackdropImage(`https://image.tmdb.org/t/p/original${data.backdrop_path}`);
          }
        } catch (error) {
          console.error("Error fetching backdrop:", error);
        }
      };
      fetchBackdrop();
    } else {
      setBackdropImage(null);
    }
  }, [trailerVideo, movieId]);
  
  if (!trailerVideo?.key) {
    if (backdropImage) {
      return (
        <div className='w-screen aspect-video relative bg-black'>
          <img
            src={backdropImage}
            alt="Movie backdrop"
            className='w-screen aspect-video object-cover'
          />
          <div className='absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent' />
        </div>
      );
    }
    return (
      <div className='w-screen aspect-video bg-black flex items-center justify-center'>
        <div className='text-white'>Loading...</div>
      </div>
    );
  }
  
  return (
    <div>
      <iframe
        key={trailerVideo.key}
        className='w-screen aspect-video'
        src={
          "https://www.youtube.com/embed/" +
          trailerVideo.key +
          "?autoplay=1&mute=1&controls=0&modestbranding=1&rel=0&showinfo=0&fs=0&disablekb=1&iv_load_policy=3&loop=1"
        }
        title='YouTube video player'
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      >
      </iframe>
    </div>
  );
}

export default VideoBackground
